import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Table,
  InputNumber,
  Popconfirm,
  Typography,
  Tag,
  Tooltip,
} from "antd";
import Page from "_components/Page";
import { materialTypeService } from "_services";

import Search from "./Search";

function List({ history, match }) {
  const { path } = match;
  const [form] = Form.useForm();
  const { Option } = Select;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [stockClassificationTypeId, setStockClassificationTypeId] = useState();
  const [finishedProducts, setFinishedProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState();
  const [currencies, setCurrencies] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [forecastValue, setForecastValue] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useState("");
  // useEffect(() => {
  //   getStockClassificationIdForFinishedProduct();
  // }, []);

  // const getStockClassificationIdForFinishedProduct = () => {
  //   setIsLoading(true);
  //   stockClassificationService
  //     .getSuggestion()
  //     .then((x) => {
  //       setIsLoading(false);
  //       const classifications = x.content;

  //       if (classifications) {
  //         const finishedProductId = classifications.find(
  //           (singleClassification) => {
  //             return singleClassification.name === "FINISHED PRODUCT";
  //           }
  //         );
  //         if (finishedProductId) {
  //           setStockClassificationTypeId(finishedProductId.id);
  //         } else {
  //           throw new Error(`Can not find stock classifications"}`);
  //         }
  //       } else {
  //         throw new Error(`Can not find stock classifications"}`);
  //       }
  //     })
  //     .catch((error) => {
  //       setError(error);
  //       setIsLoading(false);
  //     });
  // };

  // const getFinishedProducts = () => {
  //   setIsLoading(true);

  //   materialTypeService
  //     .getAllFinished()
  //     .then((data) => {
  //       setFinishedProducts(data.content);
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       setError(error);
  //       setIsLoading(false);
  //     });
  // };

  const getFinishedProducts = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setIsLoading(true);

    materialTypeService
      .searchFinished(`${searchParams}${paginationParams}`)
      .then((data) => {
        setFinishedProducts(data.content);
        setTotalRecords(data.pagination.totalRecords);
        setPageNumber(data.pagination.pageNumber);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  };

  //use the stock classification id to get finished products
  useEffect(() => {
    // if (stockClassificationTypeId) {
    getFinishedProducts(pageNumber, pageSize);
    //getFinishedProducts();
    //}
  }, []);

  const materialTableColumns = [
    {
      title: "HS Code / Finished Product",
      dataIndex: "code",
      key: "hsCode",
      //width: "4%",
      render: (text, record) => (
        <Link to={`${path}/${record.id}/summary`}>{text}</Link>
      ),
    },
    {
      title: "Product Code",
      dataIndex: "secondaryCode",
      key: "secondaryCode",
      //width: "8%",
      render: (text, record) => (
        <Tooltip title={text}>{text?.substring(0, 8)}</Tooltip>
      ),
    },
    {
      title: "Name of the Product / Name of the Bom",
      dataIndex: "name",
      key: "itemName",
      //width: "20%",
      render: (text, record) => record.name,
    },
    {
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      render: (mode) => {
        let color = "";
        if (mode === "COMPLETE") {
          color = "#87d068";
        }
        if (mode === "OPEN") {
          color = "#2db7f5";
        }
        if (mode === "UPDATE") {
          color = "#108ee9";
        }
        return <Tag color={color}>{mode}</Tag>;
      },
    },
  ];
  const handlePaginateChange = (pageNumber, pageSize) => {
    getFinishedProducts(pageNumber, pageSize);
  };

  const handleSearchResults = (results, totalRecords, searchParams) => {
    setFinishedProducts(results);
    setTotalRecords(totalRecords);
    setSearchParams(searchParams);
    setPageNumber(1);
    setIsLoading(false);
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom/boms">BOM</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom/boms">BOMs</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Link to={`${path}/upload`} key="btn-bom-upload">
            <Button>BOM Upload</Button>
          </Link>,
        ]}
      >
        <Page inner error={error}>
          <Search
            showSearchLoading={setIsLoading}
            onSearchResults={handleSearchResults}
          />
          <Table
            bordered
            //pagination={false}
            columns={materialTableColumns}
            dataSource={finishedProducts}
            size="small"
            loading={isLoading}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: false,
              onChange: { handlePaginateChange },
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
}

export default List;
